/**
 * MONETIZACIÓN por FLAGS — sin muro de pago (aún). La economía es totalmente
 * jugable con bellotas ganadas gratis (vídeo + recompensa diaria); el dinero real
 * (IAP) y la red de anuncios son opcionales y están DETRÁS DE FLAGS que arrancan
 * apagados. Ver `infra/products/famidex.md §5` (monetización, marco no bloqueante).
 *
 * F3 conectará estos flags al backend de feature-flags / a los SDK reales (Play
 * Billing / StoreKit / red de vídeo). Hasta entonces:
 *   - iapEnabled=false  → los packs se muestran pero el botón "Comprar" queda
 *     como "Próximamente" (nunca se bloquea el resto de la tienda).
 *   - rewardedAdsEnabled=false → el vídeo recompensado usa un STUB (una espera
 *     simulada) que igualmente acredita las bellotas por el endpoint server-side.
 */

export interface MonetizationFlags {
  /** Compra de packs con dinero real (IAP). Apagado = "Próximamente", sin muro. */
  iapEnabled: boolean;
  /** Red de anuncios de vídeo real. Apagado = stub simulado (igual acredita). */
  rewardedAdsEnabled: boolean;
}

/** Config por defecto: economía blanda jugable, cero muro de pago. */
export const DEFAULT_MONETIZATION: MonetizationFlags = {
  iapEnabled: false,
  rewardedAdsEnabled: false,
};
